import { useState, useEffect } from "react";
import ButtonPrimary from "./ButtonPrimary";
import ButtonSecondary from "./ButtonSecondary";
import type { ButtonProps } from "./Button";

export interface ChangingButtonProps extends ButtonProps {
  onClick: () => void;
  selected?: boolean;
}
const ChangingButton: React.FC<ChangingButtonProps> = ({
    children,
    onClick,
    selected = false,
    ...args
}) => {

    const handleClick = () => {
        onClick();
    };

    if (selected) {
        return (
            <ButtonPrimary
                onClick={handleClick}
                {...args}
            >
                {children}
            </ButtonPrimary>
        );
    } else {
        return (
            <ButtonSecondary
                onClick={handleClick}
                {...args}
            >
                {children}
            </ButtonSecondary>
        );
    }
}

export default ChangingButton;